module.exports = "https://www.gc-pro.gnp.com.mx/1ab5ca2503c5b9bb5cf5e2c2bbb16aa4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/imageIcon.svg
// module id = 982
// module chunks = 0